<div [attr.data-sb-qa]="'date-range-select-panel'" class="d-flex">
    <div class="d-flex flex-column justify-content-between">
        <mat-nav-list (click)="$event.stopPropagation()">
            <a mat-list-item *ngFor="let option of dateOptions; let i = index" (click)="SelectOption(option)">
                <p class="typography-body-medium base-300" [attr.data-sb-qa]="'date-range-select-panel-nav-option-' + i">{{option.Label}}</p>
            </a>
        </mat-nav-list>
        <lib-button qaTag="date-range-select-panel-clear-button" class="m-3" [kind]="ButtonKind.Link" (clicked)="ResetDateRange()">
            <ng-container label i18n="@@CommonClear">Clear</ng-container>
        </lib-button>
    </div>
    <mbsc-datepicker class="d-grid d-sm-block w-100"
        (click)="$event.stopPropagation()"
        [controls]="['calendar']"
        [min]="minDateJS"
        [max]="maxDateJS"
        select="range"
        calendarType="month"
        display="inline"
        themeVariant="light"
        [showRangeLabels]="false"
        [touchUi]="isMobile"
        [dayNamesShort]="localeInfo.AbbreviatedDayNames"
        [monthNames]="localeInfo.MonthNames"
        [monthNamesShort]="localeInfo.AbbreviatedMonthNames"
        [dayNamesMin]="localeInfo.AbbreviatedDayNames"
        [firstDay]="firstDayOfWeek"
        [rtl]="localeInfo.RightToLeft"
        [dateFormat]="dateFormat | uppercase"
        [focusOnClose]="false"
        (onChange)="DateChanged($event)"
        theme="material">
    </mbsc-datepicker>
</div>
